<template>
  <div class="my-machines-custom-owners">
    <div>
      <h2 class="my-machines-custom-owners__title">
        {{ t('customMachineOwnersTitle') }}
      </h2>
      <oie-hover-list>
        <li v-for="item in customMachineOwnerTypes" :key="item.value">
          <oie-editable-content :display-value="item.text" @change="updateCustomMachineOwner({id: item.value, name: $event})" @delete="handleDelete(item)"></oie-editable-content>
        </li>
      </oie-hover-list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapGetters('myMachines', ['machineOwnerTypes', 'machineCustomFieldOptions']),
    customMachineOwnerTypes() {
      return _.filter(this.machineOwnerTypes, type => type.custom)
    }
  },
  methods: {
    ...mapActions('myMachines', ['updateCustomMachineOwner', 'deleteCustomMachineOwner']),
    handleDelete(item) {
      this.publish('modal.show.generic', {
        header: `Are you sure you want to delete ${item.text}?`,
        text: `This action can not be undone`,
        buttons: [ {
          text: `Delete ${item.text}?`,
          usePrimaryButton: true,
          handler: async () => {
            await this.deleteCustomMachineOwner({ id: item.value })
            this.publish('modal.hide.generic')
          }
        }]
      })
    }
  }
}
</script>

<style lang="scss">
.my-machines-custom-owners {
  display: grid;
  gap: measure(full);
  grid-template-columns: 1fr;

  @include media('medium') {
    grid-template-columns: repeat(2, 1fr);
  }
}

.my-machines-custom-owners__title {
  @include h3-semi-bold;
  margin-bottom: measure(quarter);
}
</style>
